import axios from 'axios';

const registrationEndpoint = '/api/selfreg';

class RegistrationAPI {
    // POST
    async handleDuplicate(token, pernr, createNew){  // Create new self registration and lock old one
        return axios({
            method: 'post',
            url: registrationEndpoint + '/new',
            data: {
                pernr: pernr,
                createNew: createNew
            },
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
    async checkExisting(token, data){  // Check for possible matching data in SAP HR and FEIAM
        return axios({
            method: 'post',
            url: registrationEndpoint + '/check-data',
            data: data,
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
    async confirmAddress(token){
        return axios({
            method: 'post',
            url: registrationEndpoint + '/address',
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }

    // PUT
    async updateAddress(token, data){
        return axios({
            method: 'put',
            url: registrationEndpoint + '/address',
            data: data,
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
    // GET
    async getAddress(token){
        return axios({
            method: 'get',
            url: registrationEndpoint + '/address',
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
    async getUserName(token){
        return axios({
            method: 'get',
            url: registrationEndpoint + '/name',
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
}

export default new RegistrationAPI();
